// extracted by mini-css-extract-plugin
export default {"HeaderLevel2":"HeaderLevel2__HeaderLevel2___X7MfU","centered":"HeaderLevel2__centered___dbhQX"};